// check if current path is /auth/*
export const isAuthPage = ({ route }) => {
    if( route.path.indexOf('/auth') !== -1)
        return true;
    
    if( route.path.indexOf('/login') !== -1)
        return true;

    if( route.path.indexOf('/register') !== -1)
        return true;

    if( route.path.indexOf('/reset/') !== -1)
        return true;

    if( route.path.indexOf('/verification') !== -1)
        return true;

    return false;
}

// check if navigation should be displayed
// if route.path does not exist yet returns false
export const shouldShowNavigation = ({ route }, getters) => (route.path ? !getters.isAuthPage : false);

export const helpIconRoutes = (state) => state.help_icon_route
export const routesEmpty = (state) => state.help_icon_route.length === 0


// WEBPACK FOOTER //
// ./src/store/getters.js